const SessionStorageWithFallback = (function () {
    return {
        sessionStoreSupport: sessionStoreSupport,
        set: set,
        get: get,
        del: del
    };

    function sessionStoreSupport() {
        try {
            return 'sessionStorage' in window && window['sessionStorage'] !== null;
        } catch (e) {
            return false;
        }
    }
    function set(name, value) {
        if (value === undefined || value === null || value === '') {
            del(name);
        } else if (sessionStoreSupport()) {
            sessionStorage.setItem(name, value);
        } else {
            document.cookie = `${name}=${value}; path=/`;
        }
    }
    function get(name) {
        let ret;
        if (sessionStoreSupport()) {
            ret = sessionStorage.getItem(name);
            switch (ret) {
                case 'true':
                    return true;
                case 'false':
                    return false;
                default:
                    return ret;
            }
        } else {
            const nameEquals = `${name}=`;
            const ca = document.cookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) === ' ') {
                    c = c.substring(1, c.length);
                }
                if (c.indexOf(nameEquals) === 0) {
                    ret = c.substring(nameEquals.length, c.length);
                    switch (ret) {
                        case 'true':
                            return true;
                        case 'false':
                            return false;
                        default:
                            return ret;
                    }
                }
            }
            return null;
        }
    }

    function del(name) {
        if (sessionStoreSupport()) {
            sessionStorage.removeItem(name);
        } else {
            document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
        }
    }
})();

const LocalStorageWithFallback = (function () {
    return {
        localStoreSupport: localStoreSupport,
        set: set,
        get: get,
        del: del
    };

    function localStoreSupport() {
        try {
            return 'localStorage' in window && window['localStorage'] !== null;
        } catch (e) {
            return false;
        }
    }

    function set(name, value) {
        if (value === undefined || value === null || value === '') {
            LocalStorageWithFallback.del(name);
        } else if (LocalStorageWithFallback.localStoreSupport()) {
            localStorage.setItem(name, value);
        } else {
            document.cookie = name + '=' + value + '; expires=Thu, 31 Dec 2099 00:00:00 UTC; path=/';
        }
    }

    function get(name) {
        var ret;
        if (LocalStorageWithFallback.localStoreSupport()) {
            ret = localStorage.getItem(name);
            switch (ret) {
                case 'true':
                    return true;
                case 'false':
                    return false;
                default:
                    return ret;
            }
        } else {
            const nameEquals = name + '=';
            const ca = document.cookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) === ' ') {
                    c = c.substring(1, c.length);
                }
                if (c.indexOf(nameEquals) === 0) {
                    ret = c.substring(nameEquals.length, c.length);
                    switch (ret) {
                        case 'true':
                            return true;
                        case 'false':
                            return false;
                        default:
                            return ret;
                    }
                }
            }
            return null;
        }
    }

    function del(name) {
        if (LocalStorageWithFallback.localStoreSupport()) {
            localStorage.removeItem(name);
        } else {
            document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';
        }
    }
})();
